import { AppConfig } from "@/lib/nemmp/app-config/types";
import { PlausibleScript } from "./PlausibleScript";

type WebPageWrapperProps = {
  appConfig: AppConfig;
  children: React.ReactNode;
};

export const WebPageWrapper = ({
  children,
  appConfig,
}: WebPageWrapperProps) => {
  return (
    <>
      <PlausibleScript appConfig={appConfig} />
      {children}
    </>
  );
};
